import {del, get, post, put} from './http';

// The list pages a view can be saved on, mirroring SavedViewPages server-side.
export type SavedViewPage = 'content' | 'queue';

// One of the caller's saved views. `query` is opaque to the API: each page defines and validates its
// own shape (lib/savedViews.ts for Content).
export type SavedView = {
  id: string;
  page: SavedViewPage;
  name: string;
  query: Record<string, unknown>;
  updated_at: string;
};

// SavedViewsController limits: CreateSavedViewRequest.MaxNameLength.
export const SAVED_VIEW_NAME_MAX_LENGTH = 60;

export const savedViewsApi = {
  list: async (page: SavedViewPage) => get<SavedView[]>('/me/saved-views', {page}),
  create: async (page: SavedViewPage, name: string, query: object) =>
    post<{page: SavedViewPage; name: string; query: object}, SavedView>('/me/saved-views', {
      page,
      name,
      query
    }),
  update: async (id: string, change: {name?: string; query?: object}) =>
    put<{name?: string; query?: object}, SavedView>(`/me/saved-views/${id}`, change),
  remove: async (id: string) => del(`/me/saved-views/${id}`)
};
